<div class="clsCardModal">
  <div class="modal-body break-word" style="padding: 0">
    <div style="width: 100%; height: auto; text-align: center">
      <img class="clsLoading" src="../../../assets/images/icons/loading.png" />
      <div class="clsDlgInfo_Title">{{ title }}</div>
    </div>
  </div>
</div>
